import axios from "axios";

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;
const requestConfig = {
  timeout: 10000,
};

function handleAuthError(error) {
  console.log(error);

  if (error?.response?.status === 401) {
    localStorage.removeItem("jwToken");
    localStorage.removeItem("userId");
    window.location.href = "/";
  }
}

export async function CreateQuizFormData(
  userId,
  quizTitle,
  quizType,
  timer_for_eachQuestion,
  createdAt_date,
  questions,
  setQuizId
) {
  try {
    const reqUrl = `${backendBaseUrl}/quiz/create-quiz`;
    const reqPayload = {
      userId: userId,
      quizTitle: quizTitle,
      quizType: quizType,
      timer_for_eachQuestion: timer_for_eachQuestion,
      createdAt_date: createdAt_date,
      questions: questions,
    };
    const jwToken = JSON.parse(localStorage.getItem("jwToken"));
    const headers = {
      jwtoken: `${jwToken}`,
    };
    return await axios
      .post(reqUrl, reqPayload, { ...requestConfig, headers })
      .then((response) => {
        setQuizId(response.data.quizId);
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        handleAuthError(error);
        throw error;
      });
  } catch (error) {}
}

export async function GetAllQuizData(userId) {
  if (!userId || userId === "null" || userId === "undefined") {
    return { quizData: [] };
  }

  try {
    const reqUrl = `${backendBaseUrl}/quiz/quiz-data/${userId}`;
    const jwToken = JSON.parse(localStorage.getItem("jwToken"));
    const headers = {
      jwtoken: `${jwToken}`,
    };

    return await axios
      .get(reqUrl, { ...requestConfig, headers })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        handleAuthError(error);
        throw error;
      });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetQuizDataById(quizId) {
  try {
    const reqUrl = `${backendBaseUrl}/quiz/get-quiz/${quizId}`;

    return await axios
      .get(reqUrl, requestConfig)
      .then((response) => {
        // console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function logQuizImpression(quizId) {
  try {
    const reqUrl = `${backendBaseUrl}/quiz/log-impression/${quizId}`;

    return await axios
      .patch(reqUrl, {}, requestConfig)
      .then((res) => res.data.data)
      .catch((error) => {
        console.log(error);
        throw error;
      });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function logAnswer(questionId, index_selected_by_user) {
  if (!questionId || index_selected_by_user === undefined) return;
  try {
    const reqUrl = `${backendBaseUrl}/quiz/log-answer`;
    const reqPayload = {
      questionId: questionId,
      index_selected_by_user: index_selected_by_user,
    };

    return await axios
      .patch(reqUrl, reqPayload, requestConfig)
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  } catch (error) {}
}

export async function logVotingCount(quizId, questionIndex, optionIndex) {
  console.log(quizId, questionIndex, optionIndex);
  try {
    const response = await axios.patch(
      `${backendBaseUrl}/quiz/log-voting-count/${quizId}/${questionIndex}/${optionIndex}`,
      {},
      requestConfig
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to log voting count"
    );
  }
}

export async function DeleteQuizDataById(quizId) {
  try {
    const reqUrl = `${backendBaseUrl}/quiz/${quizId}`;
    const jwToken = JSON.parse(localStorage.getItem("jwToken"));
    const headers = {
      jwtoken: `${jwToken}`,
    };

    return await axios
      .delete(reqUrl, { ...requestConfig, headers })
      .then((response) => {
        // console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        handleAuthError(error);
        throw error;
      });
  } catch (error) {}
}

export async function editFormData(quizId, updatedQuestionsData) {
  try {
    const reqUrl = `${backendBaseUrl}/quiz/edit-quiz/${quizId}`;
    const jwToken = JSON.parse(localStorage.getItem("jwToken"));
    const headers = {
      jwtoken: `${jwToken}`,
    };
    const response = await axios.patch(reqUrl, updatedQuestionsData, {
      ...requestConfig,
      headers,
    });
    console.log(response.data.data);
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}
